const mediator = require('./mediator.js');


class Steps {
    constructor(arr) {
        this._active;
        this._collection = [];
        this.add(arr);
    }
    add(steps) {
        this._collection = this._collection.concat(steps);
        if (typeof this.active === 'undefined' && this._collection.length > 0) {
            this.active = this._collection[0];
        }
    }
    find(props) {
        if (typeof props === 'object') {
            return this._collection.find(item => {
                let result = [];
                for (let key in props) {
                    if (props.hasOwnProperty(key)) {
                        if (Array.isArray(props[key])) {
                            result.push(props[key].indexOf(item[key]) > -1);
                        } else {
                            result.push(item[key] === props[key]);
                        }
                    }
                }
                return result.every(item => item === true);
            });
        } else if (typeof props === 'number') {
            return this._collection.find(item => {
                return item.id === props;
            });
        }
    }
    get min() {
        let sorted = this._collection.sort((a, b) => {
            return a.frame - b.frame;
        });

        return sorted[0];
    }
    get max() {
        let sorted = this._collection.sort((a, b) => {
            return b.frame - a.frame;
        });

        return sorted[0];
    }
    get active() {
        return this._active;
    }
    set active(step) {
        if (!step) {
            throw new Error("Аргументом должен быть передан объект step");
        }

        let index = this._collection.findIndex(s => {
            return step === s;
        });

        if (index > -1) {
            this._active = step;
        } else {
            throw new Error("Нету такого step");
        }

        mediator.publish('steps:setactive', step);
    }
    get next() {
        let index = this._collection.findIndex(item => {
            return item === this.active;
        });
        return typeof this._collection[index + 1] !== 'undefined' ? this._collection[index + 1] : false;
    }
    get prev() {
        let index = this._collection.findIndex(item => {
            return item === this.active;
        });
        return typeof this._collection[index - 1] !== 'undefined' ? this._collection[index - 1] : false;
    }
    get breaks() {
        return this._collection.map(item => {
            return item.frame;
        });
    }
    nearestStep(frame, _stopList) {
        let result = this.active;
        let distance = Infinity;
        let stopList = [].concat(_stopList);

        let collection = this._collection.filter(item => {
            return stopList.indexOf(item) < 0;
        });

        collection.forEach(item => {
            let newDistance =  Math.abs(item.frame - frame);
            if (newDistance < distance) {
                distance = newDistance;
                result = item;
            }
        });
        // console.log(result);
        return result;
    }
}

module.exports = Steps;


// WEBPACK FOOTER //
// ./js/steps.js